import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { DashboardQueryProps,StaffSession  } from "@customTypes/dashboard";

import { dashboardQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);

  const newData = {} as StaffSession;
  if (Object.keys(res.data).length) {
    const {
      total_time_spent = 0,
      total_sessions = 0,
      avg_session_duration = 0,
      full_name = "",
    } = res.data.data;
    newData.totalSessions = total_sessions;
    newData.avgSessionDuration = Math.round(avg_session_duration / 60); // Convert seconds into minutes
    newData.totalTimeSpent = Math.round(total_time_spent / 60); // Convert seconds into minutes
    newData.name = full_name;
    return newData;
  }

  return null;
};

export const useGetSingleStaffSession = ({
  dateRange,
  startDate,
  endDate,
  userId,
}: DashboardQueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.singleStaffSessionWithFilters({
      dateRange,
      startDate,
      endDate,
      userId,
    }),
    queryFn: () => {
      return api.get(`analytics/staff/session/${userId}`, {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
          ...(userId && {
            staff_id: userId,
          }),
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Single Staff Session]", res);
      handleErrors(res, "query");
    },
  });
};
